import React from 'react';

import { Button, Title, Dialog, Progress} from 'sg-styleguide';
import GearLoader from '../gear-loader';

const InstallationDialog = (props) => {
	if (props.status === "inprogress") { 
		return (
			<Dialog>
				<GearLoader/>
				<Title level="3" weight="regular" color="darkest">
					{window.wizardData.strings.installation_title}
				</Title>

				<div style={{ marginBottom: '24px', width: '100%' }}>
					<span style={{ visibility: 'hidden' }}>{props.message}</span>
					<Progress percent={props.percent} />
				</div>

				{props.message}
			</Dialog>
		)
	} else {
		return(
			<Dialog
				state={ props.status === 'completed' ? 'active' : 'inactive' }
				icon={ props.status === 'completed' ? 'check' : 'cross' }
				size="large"
				title={ props.status === 'completed' ? window.wizardData.strings.success_title : window.wizardData.strings.fail_title }
				footer={(
					<div>
						<Button
							color="primary"
							type={ props.status === 'failed' ? 'outlined' : 'default' }
							onClick={e => props.onClick( window.wizardData.dashboard_url, false )}
						>
							{window.wizardData.strings.dashboard_button_text}
						</Button>
						{
							props.status === 'failed' &&
							<Button
								color="primary"
								onClick={props.restart}
							>
								{window.wizardData.strings.restart_button_text}
							</Button>
						}

						{
							props.status === 'completed' &&
							<Button
								color="primary"
								onClick={e => props.onClick( window.wizardData.site_url, false )}
							>
								{window.wizardData.strings.view_site}
							</Button>
						}
					</div>
				)}
			>
				{ props.status === 'completed' ? window.wizardData.strings.success_subtitle : window.wizardData.strings.fail_subtitle }
			</Dialog>

		);
	}
}

export default InstallationDialog;
